import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromGateWay from './reducers/gateway.reducer';
import * as fromGateWayMib from './reducers/gateway-mib.reducer';
import * as fromGateWayTrap from './reducers/gateway-trap.reducer';
import * as fromGateWayAttribute from './reducers/gateway-attribute.reducer';
import * as fromGateWayProfile from './reducers/gateway-profile.reducer';
import * as fromGateWayDiscovery from './reducers/gateway-discovery.reducer';
import * as fromGateWayDevice from './reducers/gateway-device.reducer';
import { GateWayEffects } from './effects/gateway.effects';
import { GateWayMibEffects } from './effects/gateway-mib.effects';
import { GateWayTrapEffects } from './effects/gateway-trap.effects';
import { GateWayAttributeEffects } from './effects/gateway-attribute.effects';
import { GateWayProfileEffects } from './effects/gateway-profile.effects';
import { GateWayDiscoveryEffects } from './effects/gateway-discovery.effects';
import { GateWayDeviceEffects } from './effects/gateway-device.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('gatewayList', fromGateWay.reducer),
    StoreModule.forFeature('gatewayDeviceList', fromGateWayDevice.reducer),
    StoreModule.forFeature('gatewayResultAddToCloud', fromGateWayDevice.addToCloudReducer),
    StoreModule.forFeature('gatewayMgtMibTrapList', fromGateWayMib.reducer),
    StoreModule.forFeature('gatewayMgtMibDetail', fromGateWayMib.mgtMibDetailReducer),
    StoreModule.forFeature('gatewayMgtTrapDetail', fromGateWayTrap.mgtTrapDetailReducer),
    StoreModule.forFeature('gatewayTrapDetail', fromGateWayTrap.trapDetailReducer),
    StoreModule.forFeature('gatewayMibTrapList', fromGateWayMib.mibTrapListReducer),
    StoreModule.forFeature('gatewayMibDetail', fromGateWayMib.mibDetailReducer),
    StoreModule.forFeature('gatewayCategoryList', fromGateWayMib.categoryListReducer),
    StoreModule.forFeature('gatewayProfileInfo', fromGateWayProfile.profileInfoReducer),
    StoreModule.forFeature('gatewayProfileList', fromGateWayProfile.profileListReducer),
    StoreModule.forFeature('gatewayMgtAttribute', fromGateWayAttribute.reducer),
    StoreModule.forFeature('gatewayDiscoveryInfo', fromGateWayDiscovery.discoveryInfoReducer),
    StoreModule.forFeature('gatewayDiscoveryInfoList', fromGateWayDiscovery.discoveryInfoListReducer),
    StoreModule.forFeature('gatewayExecuteDiscovery', fromGateWayDiscovery.executeDiscoveryReducer),
    StoreModule.forFeature('gatewayExecuteDiscoveryList', fromGateWayDiscovery.executeDiscoveryListReducer),
    StoreModule.forFeature('gatewayDiscoveryResultList', fromGateWayDiscovery.discoveryResultListReducer),
    StoreModule.forFeature('gatewayDiscoveryExecutingResultForOneTime', fromGateWayDiscovery.discoveryExecutingResultForOneTimeReducer),
    EffectsModule.forFeature(
      [
      GateWayEffects,
      GateWayMibEffects,
      GateWayTrapEffects,
      GateWayAttributeEffects,
      GateWayProfileEffects,
      GateWayDiscoveryEffects,
      GateWayDeviceEffects])
  ]
})
export class GateWayModule { }
